import { Pipe, PipeTransform } from '@angular/core';
import { LOCALE_DE } from '@app/@core/constants/common.constants';

@Pipe({
  name: 'transformNumber',
})
export class TransformNumberPipe implements PipeTransform {
  transform(value: number): string {
    //Si ponemos "es-ES" como locale no pone los puntos de los miles
    const truncatedValue = Math.floor(value * 100) / 100; // rounded 2 decimal places
    return new Intl.NumberFormat(LOCALE_DE, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(truncatedValue);
  }
}
